// export const firebaseConfig = {
//   apiKey: "AIzaSyBDf0NcshVoS63EgfUgo5qOHhjrCdt3RWU",
//   authDomain: "estetica-app-test.firebaseapp.com",
//   projectId: "estetica-app-test",
//   storageBucket: "estetica-app-test.appspot.com",
//   messagingSenderId: "24192095998",
//   appId: "1:24192095998:web:b8b5a569caf7ee9d5f77af",
// };

//Mumbai
// export const firebaseConfig = {
//   apiKey: "AIzaSyDeChBZp3gWnhc20kqmz8ZgO4SJX7ZOw7Y",
//   authDomain: "iconecta001.firebaseapp.com",
//   databaseURL: "https://iconecta001.firebaseio.com",
//   projectId: "iconecta001",
//   storageBucket: "iconecta001.appspot.com",
//   messagingSenderId: "959813980522",
//   appId: "959813980522",
// };

//Sonia cases
export const firebaseConfig = {
  apiKey: "AIzaSyDRKYTRIAQ8g0mhdWMpEpCp95RsaQuVzG4",
  authDomain: "iconecta002.firebaseapp.com",
  databaseURL: "https://iconecta002.firebaseio.com",
  projectId: "iconecta002",
  storageBucket: "iconecta002.appspot.com",
  messagingSenderId: "254082098434",
  appId: "1:254082098434:web:750b8fa48c6bacbd468e1b",
  measurementId: "G-43JZB48QVL",
};

export const EXPECTED_API_VERSION: string = "v2";
